<template>
  <div class="about">
    <Header/>
      <div class="body">
        <div class="sobre">
          <transition name="bounce">
            <h1 v-if="show" class="msgs">Faça SAPIÊNCIA!</h1>
          </transition><br>
          <div id="localizacao">
            <div class="img_location">
              <h2 class="p_sobre">O Sapiência</h2>
               <p class="p_sobre">
                 O Cursinho Sapiência foi idealizado pela Professora de Português Eliane Limonti da Fonseca, que desde 1999, época em que estudava na USP (Universidade de São Paulo), já tinha o sonho de atuar como professora no período mais importante da vida dos estudantes, que é a escolha da sua vida profissional e entrada na universidade.
                 Assim embrenhou-se em várias frentes de trabalho sempre buscando estratégias diferenciadas que auxiliassem os alunos a avançarem em seus saberes e atingirem sua meta. No início oferecia cursos de Literatura e Redação, o sucesso nos mesmos foi o que instigou-a em 2012 a abrir a primeira turma de cursinho completo, que obteve um alto índice de aprovação.
                 <p class="p_sobre"> Hoje o Sapiência é reconhecido por oferecer uma proposta pedagógica diferenciada, que valoriza as trocas de experiência, a proximidade no ensino e o dinamismo nas metodologias. Logo, contamos com materiais desenvolvidos pelos próprios professores, aulas de reconhecimento de meio (aulas externas), aulas de metodologia ativa e, ainda, com o Projeto Canguru. O qual permite que os alunos tenham uma tutoria ao longo do ano, recebendo planos de estudos e orientação individualizada.  </p>
               </p>
            </div>
            <div class="img_location">
              <h2 class="p_sobre">Missão</h2>
              <p class="p_sobre">
                A missão do Sapiência é guiar o aluno em seus estudos, permitindo alto aprofundamento nos conteúdos, através de um contato direto com seu professor, recebendo orientação individualizada, acesso a material didático qualificado e recursos audiovisuais e tecnológicos que oferecem suporte adequado para cada aluno desenvolver suas múltiplas inteligências.
                O Cursinho Sapiência acredita na capacidade do ser humano em vencer dificuldades e trilhar caminhos rumo ao seu sonho profissional, pois estudar não é para o agora é para a vida!
              </p>
            </div>
          </div>
          <div id="localizacao">
            <div class="img_location">
              <h1> <font-awesome-icon icon="book-reader" class="icon_spot"/> </h1>
              <h4 class="txt_endereco">Material</h4>
              <p class="txt_endereco">
                <p> Veja nossos materias </p>
                <router-link to="/material"> <p pill variant="outline-secondary" id="ver_mais"> Ver mais... </p> </router-link>
              </p>
            </div>
            <div class="img_location">
              <h1> <font-awesome-icon icon="chalkboard-teacher" class="icon_spot"/> </h1>
              <h4 class="txt_endereco">Fotos</h4>
              <p class="txt_endereco">
                <p> Veja algumas fotos </p>
                <router-link to="/galeria"> <p pill variant="outline-secondary" id="ver_mais"> Ver mais... </p> </router-link>
              </p>
            </div>
            <div class="img_location">
              <h1> <font-awesome-icon icon="file-signature" class="icon_spot"/> </h1>
              <h4 class="txt_endereco">Espaço</h4>
              <p class="txt_endereco">
                <p>Conheça nosso espaço</p>
                <router-link to="/espaco"> <p pill variant="outline-secondary" id="ver_mais"> Ver mais... </p> </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    <Footer/>
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  name: 'about',
  mounted() {
    this.change();
  },
  components:{
    Header,
    Footer
  },
  data (){
    return{
      show: false
    }
  },
  methods:{
    change(){
      this.show=true
    }
  }
}
</script>

<style>
 @import "../assets/style_padrao.css";
  .bounce-enter-active {
  animation: bounce-in .5s;
  }
  .bounce-leave-active {
  animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(2);
    }
    100% {
      transform: scale(1);
    }
  }
  #ver_mais{
    color:purple;
  }
</style>
